<template>
  <div class="auth-container">
    <!-- 查询区域 -->
    <div class="query-section">
      <el-form :inline="true" class="query-form">
        <el-form-item label="用户">
          <el-autocomplete v-model="user" :fetch-suggestions="querySearch" placeholder="请输入用户名"
            @select="handleIconClick" size="medium" clearable>
            <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="授权码">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearch" placeholder="请输入授权码"
            @select="handleIconClick" size="medium" clearable>
            <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getCodes" size="medium">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="authCodeList" v-loading="loading" :height="tableHeight" stripe class="auth-table">
        <el-table-column prop="authCode" label="授权码" min-width="200"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已注册' ? 'success' : 'info'" size="small">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="delivered_Time" label="发货时间" min-width="160" align="center"></el-table-column>
        <el-table-column prop="delivered_To" label="发货人" min-width="120"></el-table-column>
        <el-table-column prop="order_Number" label="订单号" min-width="160"></el-table-column>
        <el-table-column prop="register_Expired_Date" label="过期时间" min-width="160" align="center"></el-table-column>
        <el-table-column prop="registered_Time" label="注册时间" min-width="160" align="center"></el-table-column>
        <el-table-column prop="registered_By" label="用户" min-width="120"></el-table-column>
        <el-table-column prop="registered_Product" label="注册产品" min-width="150"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination background :page-size="pageSize" :current-page="pageIndex" :total="totalCount"
          :page-sizes="[15, 30, 50]" layout="total, sizes, prev, pager, next, jumper" @current-change="currentChange"
          @size-change="handleSizeChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
export default {
  name: 'auth',
  data () {
    return {
      tableHeight: 0,
      alertTip: false,
      alertaddTip: false,
      code: '',
      user: '',
      loading: false,
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      authCodeList: []
    }
  },
  created () {
    this.tableHeight = (window.innerHeight - 280)
    this.getCodes()
  },
  mounted () {

  },
  methods: {
    getCodes () {
      this.loading = true
      this.$axios.post(api.queryAuthCode, { PageIndex: this.pageIndex, PageSize: this.pageSize, Code: this.code, user_Name: this.user })
        .then(res => {
          this.loading = false
          this.authCodeList = res.data.result.items
          this.totalCount = res.data.result.totalCount
        })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getCodes()
    },
    handleIconClick (item) {
      this.keyword = item.Id
      this.getCodes()
    },
    querySearch (keyword, callback) {
      if (keyword === '') {
        return
      }
      var queryList = []
      this.$axios.get(api.autocomplete(keyword))
        .then(res => {
          res.data.result.items.forEach((item, index) => {
            queryList.push({ value: item.authCode, Id: item.authCode })
          })
        })
      return callback(queryList)
    },
    currentChange (current) {
      this.pageIndex = current
      this.getCodes()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.auth-container {
  padding: $spacing-lg;
  background: var(--bg-base);
  min-height: calc(100vh - 120px);
}

.query-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  padding: $spacing-lg;
  margin-bottom: $spacing-lg;
  box-shadow: var(--shadow-base);

  .query-form {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-md;
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
      margin-right: $spacing-md;

      ::v-deep .el-form-item__label {
        font-weight: 500;
        color: var(--text-primary);
      }
    }
  }
}

.table-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  padding: $spacing-lg;
  box-shadow: var(--shadow-base);

  .auth-table {
    width: 100%;
    border-radius: $border-radius-sm;
    overflow: hidden;

    ::v-deep th {
      background: var(--bg-elevated);
      color: var(--text-primary);
      font-weight: 600;
    }

    ::v-deep td {
      color: var(--text-regular);
    }
  }
}

.pagination-section {
  margin-top: $spacing-lg;
  text-align: center;

  ::v-deep .el-pagination {

    .el-pagination__total,
    .el-pagination__jump {
      color: var(--text-regular);
    }
  }
}

// 响应式适配
@media (max-width: $screen-sm) {
  .auth-container {
    padding: $spacing-md;
  }

  .query-section {
    .query-form {
      flex-direction: column;
      align-items: stretch;

      .el-form-item {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/authcode/auth.vue